/* CW native cart drawer - behaviour matching the Kaching Cart drawer:
   open on any add-to-cart (fetch/XHR intercept, Dawn product-form hook), header cart icon, /cart links;
   quantity +/- and typed input, remove, variant swap (keeps plan + qty), upsell add, discount codes,
   express checkout, body scroll lock, focus handling. The body is re-rendered via the Section Rendering API. */
(function () {
  if (window.cwCart) return;
  var SECTION = 'cw-cart-drawer';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var host = document.querySelector('[data-cwcd]');
  if (!host) return;
  var root = host.querySelector('[data-cwcd-root]');
  var inner = root.querySelector('.cwcd__inner');
  var body = host.querySelector('[data-cwcd-body]');
  var state = { open: false, busy: false, lastFocus: null, pendingCode: '', codeError: false, refreshTimer: null, fullWallets: null };

  /* ------------------------------------------------------------------ helpers */
  function q(sel, ctx) { return (ctx || host).querySelector(sel); }
  function qa(sel, ctx) { return Array.prototype.slice.call((ctx || host).querySelectorAll(sel)); }
  function json(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, opts.headers || {});
    if (opts.body && typeof opts.body !== 'string') opts.body = JSON.stringify(opts.body);
    return fetch(url, opts).then(function (r) { return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'Cart error'); e.data = j; throw e; } return j; }); });
  }
  function setBusy(on) { state.busy = on; body.classList.toggle('is-loading', on); }

  /* ------------------------------------------------------------------ render */
  function renderFromHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cwcd-body]');
    if (!fresh) return;
    var scrollTop = q('[data-cwcd-contents]') ? q('[data-cwcd-contents]').scrollTop : 0;
    body.innerHTML = fresh.innerHTML;
    body.setAttribute('data-item-count', fresh.getAttribute('data-item-count') || '0');
    host.setAttribute('data-item-count', fresh.getAttribute('data-item-count') || '0');
    var countEl = q('[data-cwcd-count]'); if (countEl) countEl.textContent = fresh.getAttribute('data-item-count') || '0';
    inner.setAttribute('aria-label', (inner.getAttribute('aria-label') || '').replace(/\d+$/, fresh.getAttribute('data-item-count') || '0'));
    var contents = q('[data-cwcd-contents]'); if (contents) contents.scrollTop = scrollTop;
    // express buttons: reuse the page-load markup, like the Kaching embed does
    var src = host.querySelector('template[data-cwcd-express-source]');
    var slot = q('.cwcd-express');
    if (src && slot && src.innerHTML.trim()) { slot.innerHTML = expressMarkup(src.innerHTML); }
    // discount code UI state survives re-renders
    var input = q('[data-cwcd-discount-input]');
    if (input && state.pendingCode) { input.value = state.pendingCode; var apply = q('[data-cwcd-discount-apply]'); if (apply) apply.disabled = false; }
    var err = q('[data-cwcd-discount-error]'); if (err) err.hidden = !state.codeError;
    initCarousel();
    document.dispatchEvent(new CustomEvent('cwcart:rendered', { detail: { count: parseInt(fresh.getAttribute('data-item-count') || '0', 10) } }));
  }
  var walletCache = null;
  function readConfigs(html) {
    var m = html.match(/wallet-configs="([^"]*)"/); if (!m) return null;
    try { return JSON.parse(m[1].replace(/&quot;/g, '"').replace(/&amp;/g, '&')); } catch (e) { return null; }
  }
  function fetchFullWallets() {
    if (walletCache) return walletCache;
    try { var c = sessionStorage.getItem('cwcd-wallets'); if (c) { var arr = JSON.parse(c); if (arr && arr.length) { walletCache = Promise.resolve(arr); return walletCache; } } } catch (e) {}
    // A cookie-less request is rendered for an EMPTY cart, and an empty cart carries every enabled wallet.
    // Try our own section first (works once the section is on the live theme); fall back to any page that
    // outputs content_for_additional_checkout_buttons (e.g. the Kaching embed's template).
    function extract(html) { var cfg = readConfigs(html || ''); return cfg && cfg.length ? cfg : null; }
    walletCache = fetch(ROOT + '?sections=' + SECTION + '&cwcd=1', { credentials: 'omit' })
      .then(function (r) { return r.json(); }).then(function (j) { return extract(j[SECTION]); }).catch(function () { return null; })
      .then(function (cfg) {
        if (cfg) return cfg;
        return fetch(ROOT + 'cart?cwcd=1', { credentials: 'omit' }).then(function (r) { return r.text(); }).then(extract).catch(function () { return null; });
      })
      .then(function (cfg) { cfg = cfg || []; if (cfg.length) { try { sessionStorage.setItem('cwcd-wallets', JSON.stringify(cfg)); } catch (e) {} } return cfg; });
    return walletCache;
  }
  function expressMarkup(html) {
    var cur = readConfigs(html);
    if (!cur || !state.fullWallets) return html;
    var names = cur.map(function (w) { return w.name; });
    var merged = cur.slice();
    state.fullWallets.forEach(function (w) { if (names.indexOf(w.name) === -1) merged.push(w); });
    if (merged.length === cur.length) return html;
    var enc = JSON.stringify(merged).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
    return html.replace(/wallet-configs="[^"]*"/, 'wallet-configs="' + enc + '"');
  }
  function updateBubble(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('shopify-section-cart-icon-bubble');
    var bubble = document.getElementById('cart-icon-bubble');
    if (fresh && bubble) bubble.innerHTML = fresh.innerHTML;
  }
  function refresh() {
    // NB: no 'Accept: application/json' here - Shopify then leaves content_for_additional_checkout_buttons empty
    return fetch(ROOT + '?sections=' + SECTION + ',cart-icon-bubble&_=' + Date.now())
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (sections[SECTION]) renderFromHtml(sections[SECTION]);
        if (sections['cart-icon-bubble']) updateBubble(sections['cart-icon-bubble']);
      })
      .catch(function () {})
      .finally(function () { setBusy(false); });
  }
  function scheduleRefresh(delay) {
    clearTimeout(state.refreshTimer);
    state.refreshTimer = setTimeout(refresh, delay || 0);
  }

  /* ------------------------------------------------------------------ open / close */
  function open(trigger) {
    if (state.open) return;
    state.open = true;
    state.lastFocus = trigger && trigger.focus ? trigger : document.activeElement;
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cwcd-open');
    document.body.classList.add('cwcd-open', 'kaching-body__cart-open');
    // two frames so the transition runs from the translated state
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); }); });
    setTimeout(function () { try { inner.focus({ preventScroll: true }); } catch (e) {} }, 220);
    document.dispatchEvent(new CustomEvent('cwcart:open'));
  }
  function close() {
    if (!state.open) return;
    state.open = false;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cwcd-open');
    document.body.classList.remove('cwcd-open', 'kaching-body__cart-open');
    if (state.lastFocus && state.lastFocus.focus) { try { state.lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    document.dispatchEvent(new CustomEvent('cwcart:close'));
  }

  /* ------------------------------------------------------------------ cart ops */
  function changeLine(key, quantity) {
    setBusy(true);
    return json(ROOT + 'cart/change.js', { method: 'POST', body: { id: key, quantity: quantity } }).then(refresh, function () { refresh(); });
  }
  function addItems(items) {
    setBusy(true);
    return json(ROOT + 'cart/add.js', { method: 'POST', body: { items: items } }).then(function (j) { return refresh().then(function () { open(); return j; }); }, function (e) { refresh(); throw e; });
  }
  function swapVariant(row, newVariantId) {
    var item = row.closest('[data-cwcd-item]');
    var key = item.getAttribute('data-line-key');
    var qty = parseInt(item.getAttribute('data-quantity'), 10) || 1;
    var plan = item.getAttribute('data-selling-plan');
    if (String(newVariantId) === row.getAttribute('data-variant-id')) return;
    item.classList.add('is-busy'); setBusy(true);
    var line = { id: newVariantId, quantity: qty }; if (plan) line.selling_plan = plan;
    json(ROOT + 'cart/add.js', { method: 'POST', body: { items: [line] } })
      .then(function () { return json(ROOT + 'cart/change.js', { method: 'POST', body: { id: key, quantity: 0 } }); })
      .then(refresh, function () { refresh(); });
  }
  function resolveVariant(row) {
    var dataEl = row.querySelector('[data-cwcd-variants]');
    if (!dataEl) return null;
    var variants; try { variants = JSON.parse(dataEl.textContent); } catch (e) { return null; }
    var chosen = qa('select[data-cwcd-option]', row).map(function (s) { return s.value; });
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var k = 0; k < chosen.length; k++) if ((v.options[k] || v['option' + (k + 1)]) !== chosen[k]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  }
  function applyDiscount(code) {
    setBusy(true);
    state.pendingCode = code; state.codeError = false;
    return json(ROOT + 'cart/update.js', { method: 'POST', body: { discount: code } }).then(function (cart) {
      var codes = cart.discount_codes || [];
      var applied = codes.some(function (c) { return c.code.toLowerCase() === code.toLowerCase() && c.applicable; });
      state.pendingCode = ''; // Kaching clears the field either way
      state.codeError = !applied;
      return refresh();
    }, function () { state.pendingCode = ''; state.codeError = true; return refresh(); });
  }
  function removeDiscount() {
    setBusy(true); state.pendingCode = ''; state.codeError = false;
    return json(ROOT + 'cart/update.js', { method: 'POST', body: { discount: '' } }).then(refresh, refresh);
  }

  /* ------------------------------------------------------------------ carousel */
  function initCarousel() {
    var car = q('[data-cwcd-carousel]'); if (!car) return;
    var track = q('[data-cwcd-track]', car), prev = q('[data-cwcd-prev]', car), next = q('[data-cwcd-next]', car);
    var items = qa('[data-cwcd-upsell-item]', track);
    function update() {
      var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
    }
    function index() { return Math.round(track.scrollLeft / (track.clientWidth || 1)); }
    function goTo(i) { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
    // wraps around at both ends, like the Kaching carousel
    if (prev) prev.onclick = function () { var i = index(); goTo(i <= 0 ? items.length - 1 : i - 1); };
    if (next) next.onclick = function () { var i = index(); goTo(i >= items.length - 1 ? 0 : i + 1); };
    track.addEventListener('scroll', function () { clearTimeout(track.__t); track.__t = setTimeout(update, 80); }, { passive: true });
    update();
  }

  /* ------------------------------------------------------------------ events (delegated) */
  host.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-cwcd-close]')) { e.preventDefault(); close(); return; }
    var inc = t.closest('[data-cwcd-qty-inc]'), dec = t.closest('[data-cwcd-qty-dec]'), rm = t.closest('[data-cwcd-remove]');
    if (inc || dec || rm) {
      e.preventDefault();
      if (state.busy) return;
      var item = t.closest('[data-cwcd-item]'); var key = item.getAttribute('data-line-key'); var qty = parseInt(item.getAttribute('data-quantity'), 10) || 1;
      item.classList.add('is-busy');
      changeLine(key, rm ? 0 : (inc ? qty + 1 : qty - 1));
      return;
    }
    var add = t.closest('[data-cwcd-upsell-add]');
    if (add) {
      e.preventDefault();
      if (state.busy) return;
      var card = add.closest('[data-cwcd-upsell-item]'); card.classList.add('is-busy');
      addItems([{ id: parseInt(add.getAttribute('data-variant-id'), 10), quantity: 1 }]).catch(function () { card.classList.remove('is-busy'); });
      return;
    }
    var apply = t.closest('[data-cwcd-discount-apply]');
    if (apply) { e.preventDefault(); var inp = q('[data-cwcd-discount-input]'); var code = (inp && inp.value || '').trim(); if (code && !state.busy) applyDiscount(code); return; }
    var rmCode = t.closest('[data-cwcd-discount-remove]');
    if (rmCode) { e.preventDefault(); if (!state.busy) removeDiscount(); return; }
  });
  host.addEventListener('change', function (e) {
    var t = e.target;
    var row = t.closest('[data-cwcd-variant-row]');
    if (row && t.matches('select[data-cwcd-option]')) {
      var v = resolveVariant(row); if (!v) return;
      if (row.closest('[data-cwcd-item]')) { swapVariant(row, v.id); }
      else {
        // upsell card: swap image / price / button target
        var card = row.closest('[data-cwcd-upsell-item]');
        row.setAttribute('data-variant-id', v.id);
        var btn = q('[data-cwcd-upsell-add]', card); if (btn) { btn.setAttribute('data-variant-id', v.id); btn.disabled = !v.available; }
        var img = q('.cwcd-upsell-item__img', card); if (img && v.featured_image && v.featured_image.src) { img.src = v.featured_image.src.replace(/(\.[a-z]+)(\?|$)/, '_200x200$1$2'); img.removeAttribute('srcset'); }
        var price = q('[data-cwcd-upsell-price]', card);
        if (price) {
          var type = card.getAttribute('data-discount-type'), amt = parseFloat(card.getAttribute('data-discount-amount') || '0') || 0;
          var p = v.price, c = v.compare_at_price || 0;
          if (type === 'percentage' && amt > 0) { c = p; p = Math.round(p - p * amt / 100); }
          else if (type === 'fixed' && amt > 0) { c = p; p = Math.max(0, p - Math.round(amt * 100)); }
          price.innerHTML = '<span class="cwcd-upsell-item__price-final">' + money(p) + '</span>' + (c > p ? '<s class="cwcd-upsell-item__price-old">' + money(c) + '</s>' : '');
        }
      }
      return;
    }
    if (t.matches('[data-cwcd-qty-input]')) {
      var item = t.closest('[data-cwcd-item]'); var n = parseInt(t.value, 10); if (isNaN(n) || n < 0) n = 0;
      item.classList.add('is-busy'); changeLine(item.getAttribute('data-line-key'), n);
    }
  });
  host.addEventListener('input', function (e) {
    if (e.target.matches('[data-cwcd-discount-input]')) {
      var apply = q('[data-cwcd-discount-apply]'); if (apply) apply.disabled = !e.target.value.trim();
      state.pendingCode = e.target.value; if (state.codeError) { state.codeError = false; var err = q('[data-cwcd-discount-error]'); if (err) err.hidden = true; }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.open) close(); });
  host.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-cwcd-discount-input]')) { e.preventDefault(); var code = e.target.value.trim(); if (code && !state.busy) applyDiscount(code); }
    if (e.key === 'Tab' && state.open) {
      var f = qa('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])', inner).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  host.addEventListener('submit', function (e) {
    if (e.target.id === 'CwCartDrawerForm') {
      var btn = q('[data-cwcd-checkout]'); if (btn) { btn.classList.add('is-loading'); }
      // let the native POST to /cart with name=checkout go through (keeps discounts + selling plans)
    }
  });
  function money(cents) {
    var fmt = (window.cwCartMoneyFormat || (window.Shopify && window.Shopify.money_format) || '£{{amount}}');
    var v = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  /* ------------------------------------------------------------------ global hooks */
  // header cart icon + any /cart link opens the drawer
  document.addEventListener('click', function (e) {
    var a = e.target.closest('#cart-icon-bubble, a[href$="/cart"], a[href*="/cart?"], [data-cw-cart-open]');
    if (!a || a.closest('[data-cwcd]')) return;
    if (a.tagName === 'A' && !/\/cart(\?|$)/.test(a.getAttribute('href') || '') && !a.id) return;
    e.preventDefault(); e.stopImmediatePropagation();
    setBusy(true); refresh(); open(a);
  }, true);

  // Dawn's own <cart-drawer> (hidden) - route its API to us so Dawn product forms / quick-add keep working
  function patchDawn() {
    var d = document.querySelector('cart-drawer:not(.cw-cart)');
    if (!d) return;
    d.getSectionsToRender = function () { return [{ id: SECTION, selector: '[data-cwcd-body]' }, { id: 'cart-icon-bubble' }]; };
    d.renderContents = function (parsed) {
      if (parsed && parsed.sections && parsed.sections[SECTION]) { renderFromHtml(parsed.sections[SECTION]); if (parsed.sections['cart-icon-bubble']) updateBubble(parsed.sections['cart-icon-bubble']); }
      else scheduleRefresh(0);
      open();
    };
    d.open = function (trigger) { setBusy(true); refresh(); open(trigger); };
    d.close = function () { close(); };
  }
  patchDawn();
  if (window.customElements && customElements.whenDefined) customElements.whenDefined('cart-drawer').then(patchDawn).catch(function () {});

  // any add-to-cart done with fetch or XHR (GemPages, the CW PDP, Dawn, apps) refreshes + opens the drawer
  function isAdd(url) { return typeof url === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(url); }
  function isChange(url) { return typeof url === 'string' && /\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url); }
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      if (/cwcd=1/.test(url)) return p;
      if (isAdd(url)) {
        p.then(function (r) { if (r && r.ok) { scheduleRefresh(50); if (!/opens_cart=(never|false|0)/.test(url)) setTimeout(function () { open(); }, 60); } }).catch(function () {});
      } else if (isChange(url)) {
        p.then(function (r) { if (r && r.ok) scheduleRefresh(50); }).catch(function () {});
      }
      return p;
    };
  }
  if (window.XMLHttpRequest) {
    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if ((isAdd(url) || isChange(url)) && !/cwcd=1/.test(url)) {
        this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) { scheduleRefresh(50); if (isAdd(url)) setTimeout(function () { open(); }, 60); } });
      }
      return _open.apply(this, arguments);
    };
  }
  // our own requests must not be intercepted twice: mark them
  var _json = json;
  json = function (url, opts) { return _json(url + (url.indexOf('?') > -1 ? '&' : '?') + 'cwcd=1', opts); };

  (function () {
    var src = host.querySelector('template[data-cwcd-express-source]');
    if (!src) return;
    var cur = readConfigs(src.innerHTML) || [];
    fetchFullWallets().then(function (full) {
      state.fullWallets = full;
      var missing = full.some(function (w) { return !cur.some(function (c) { return c.name === w.name; }); });
      var slot = q('.cwcd-express');
      if (missing && slot && !slot.querySelector('shopify-paypal-button')) slot.innerHTML = expressMarkup(src.innerHTML);
    });
  })();
  initCarousel();
  window.cwCart = { open: function () { setBusy(true); refresh(); open(); }, close: close, refresh: refresh, add: addItems, applyDiscount: applyDiscount };
  // Kaching-compatible shim for scripts that call the app API
  if (!window.kachingCartApi) window.kachingCartApi = { openCart: function () { window.cwCart.open(); }, closeCart: close, refreshCart: refresh, getCartData: function () { return null; }, updateTieredPromotionsBar: function () { return Promise.resolve(); }, getCheckoutButtonClickHandler: function () { return null; }, setCheckoutButtonClickHandler: function () {} };
})();
